const emptyFn = () => {};
const emptyNullFn = () => null;
const emptyObj = {};
const emptyMap = new Map();
const emptyArray: any[] = [];

export { emptyFn, emptyNullFn, emptyObj, emptyMap, emptyArray };
